
export default {
  data() {
    return {
      error: {},
    };
  },
  methods: {
    async login() {
      this.error = {};
      try {
        const formData = new FormData(this.$refs.loginform);

        await this.$auth.loginWith('local', {data: formData});

        this.$gtm.push({event: 'login_form'});
      } catch (err) {
        this.$toast.error('Inloggen niet geslaagd!');
      }
    },
  },
};
